export enum WebsocketEventType {
    CREATE,
    UPDATE,
    DELETE,
}

export interface WebSocketEvent<T> {
    type: WebsocketEventType;
    model: string;
    collection: string;
    data: T;
}
